import React from 'react';
// import './homePage.css';

function homePage() {
    return(
        <article className='flex column align-items-cntr margin-t-xxl'>
            <section className='card-lg'>
                <h1 className='h1 margin-b-sm'><b>Seamless Remote Connectivity to all your devices</b></h1>
                <p className='card-body font-md margin-l-lg margin-r-lg margin-b-md'>
                    Build the Smart Home of your dreams using Command Center and have access from anywhere in the World.
                    Simply register an account, subscribe to a plan, download and install our agent software to the desired computer.
                </p>
                <video className='' controls autoPlay loop playsInline width={"100%"} height={"auto"}>
                    <source src="./assets/videos/remoteCtrldemo.mp4" type='video/mp4' />
                </video>
            </section>
            <section className='card-lg'>
                <h1 className='h1 margin-b-sm'><b>Introducing Command Center Cloud</b></h1>
                <p className='card-body font-md margin-l-lg margin-r-lg margin-b-md'>
                    We Offer Variety of Services
                    <ul>
                        <li>File Storage</li>
                        <li>Object Storage</li>
                        <li>Synthetic Testing</li>
                        <li>Container Clusters</li>
                        <li>Global Load Balancing</li>
                    </ul>
                </p>
            </section>
        </article>
    );
}

export default homePage;